import { Review } from "./review"
import avatar1 from "~/images/landing/avatar-1.png"
import avatar2 from "~/images/landing/avatar-2.png"
import avatar3 from "~/images/landing/avatar-3.png"
import { MobileBottomFooter } from "./footer/mobile-bottom-footer"
import { DesktopBottomFooter } from "./footer/desktop-bottom-footer"
import { StyledText } from "./common/styled-text"
import { cn } from "~/common/cn"

type FooterHeadingProps = {
  text: string
  isHighlighted?: boolean
}

const FooterHeading = ({ text, isHighlighted = false }: FooterHeadingProps) => {
  return (
    <StyledText
      variant={isHighlighted ? "stroke" : "default"}
      className={cn(
        "text-center md:text-left",
        isHighlighted ? "z-10 text-white" : "text-base-black"
      )}
    >
      {text}
    </StyledText>
  )
}

export function Footer() {
  return (
    <div className="w-full bg-gradient-to-t from-support-lime to-neutral-100 px-8 pt-8 md:px-16 md:pt-16">
      <div className="relative mx-auto w-full max-w-7xl sm:px-6 md:px-0">
        <div className="md:flex md:flex-row md:justify-center">
          <div className="flex flex-col items-center justify-center pb-8 md:w-1/3 md:items-start md:justify-center md:pb-0">
            <FooterHeading text="You'll" />
            <FooterHeading text="Love it" isHighlighted />
            <FooterHeading text="Here" />
          </div>

          <div className="relative flex flex-col justify-center overflow-hidden md:w-2/3 md:items-center md:justify-between md:gap-4">
            <Review
              review="“This feels so good! Whatever is happening here set-up wise is better than X / Bluesky / Reddit.“"
              avatar={avatar1}
            />
            <Review
              review="“Love it so much - all positive and fun 🫶“"
              avatar={avatar2}
              position="right"
            />
            <Review
              review="“Best way to connect with my fans - no distractions, just pure engagement.“"
              avatar={avatar3}
            />
          </div>
        </div>
      </div>

      <MobileBottomFooter />
      <DesktopBottomFooter />
    </div>
  )
}
